<template>
	<div class="date-picker-years">
		<div class="date-picker-years__header">
			<ButtonIcon
				class="date-picker-years__previous-btn"
				iconClassName="icon-arrow_left"
				@click="onClickPrevious"
			/>
			<h5 class="date-picker-years__label">Select a Year</h5>
			<ButtonIcon
				class="date-picker-years__next-btn"
				iconClassName="icon-arrow_right"
				@click="onClickNext"
			/>
		</div>
		<List
			class="date-picker-years__list"
			:listItems="yearList"
			@clickPrevious="onClickPrevious"
			@clickNext="onClickNext"
		>
			<template v-slot:default="slotProps">
				<ButtonSmall
					class="date-picker-years__item"
					@click="onClickYear(slotProps.item)"
					:labelText="slotProps.item"
					:selected="slotProps.item === value"
				/>
			</template>
		</List>
	</div>
</template>

<script>
import List from '@/components/shells/list/list.vue';
import ButtonSmall from '@/components/forms/button/button-small.vue';
import ButtonIcon from '@/components/forms/button/button-icon.vue';
import { getYear } from 'date-fns';

export default {
	name: 'DatePickerYears',
	components: {
		List,
		ButtonSmall,
		ButtonIcon
	},
	props: {
		value: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				const currentYear = getYear(currentDate);
				return currentYear;
			}
		},
		startYear: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				const currentYear = getYear(currentDate);
				return currentYear;
			}
		},
		columns: {
			type: Number,
			default: 3
		},
		rows: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			currentStartYear: this.startYear,
			displayCount: 12
		};
	},
	created() {
		this.displayCount = this.columns * this.rows;
	},
	computed: {
		yearList() {
			const yearArray = [];

			for (let index = 0; index < this.displayCount; index++) {
				yearArray.push(this.currentStartYear + index);
			}

			return yearArray;
		}
	},
	methods: {
		onClickPrevious() {
			this.currentStartYear = this.currentStartYear - this.columns;
			this.$emit('clickPrevious');
		},
		onClickNext() {
			this.currentStartYear = this.currentStartYear + this.columns;
			this.$emit('clickPrevious');
		},
		onClickYear(year) {
			this.$emit('input', year);
			this.$emit('change', year);
		}
	}
};
</script>

<style lang="scss" scoped>
.date-picker-years {
	&__header {
		position: relative;
		text-align: center;
		margin-bottom: $gutter-xl;
		font-size: 18px;
	}

	@include date-picker-previous-next;

	&__label {
		@include heading('md');
		text-align: center;
		margin-bottom: $gutter-sm;
		color: var(--field-fg);
	}

	&__list {
		@include date-picker-list-grid;
	}
}
</style>
